/*
Created request Reducer to reset questionnaire state
 */
export const questionnaireEvaluationResetReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { questionList: [], isSaveSuccess: false, evaluationDocId: 0 });
};
//# sourceMappingURL=questionnaireEvaluationResetReducer.js.map